<!-- <select class="form-select form-select-sm" name="filterAppType" required [(ngModel)]="filterAppType"
    (ngModelChange)="onChange($event)" id="{{fromComponent}}-{{sectionName}}-filterAppType" #appType="ngModel">
    <option id="{{fromComponent}}-{{sectionName}}-filterAppType-all" value="ALL">ALL</option>
    <option *ngFor="let item of appTypes" id="{{fromComponent}}-{{sectionName}}-filterAppType-{{item}}">
        {{item}}
    </option>
</select> -->

<div class="dropdown categoryDropdown">
    <button class="btn btn-custom-pri btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown"
        aria-expanded="false" id="{{fromComponent}}-{{sectionName}}-filterAppType">
        <span id="{{fromComponent}}-{{sectionName}}-filterAppTypeText">ALL</span>
    </button>
    <ul class="dropdown-menu">
        <li (click)="onDDChange('ALL')"
        id="{{fromComponent}}-{{sectionName}}-filterAppType-ALL">
            <a class="dropdown-item" href="javascript:void(0)">ALL</a>
        </li>
        <li *ngFor="let item of appTypes" (click)="onDDChange(item)"
        id="{{fromComponent}}-{{sectionName}}-filterAppType-{{item}}">
            <a class="dropdown-item" href="javascript:void(0)">
                {{item}}
            </a>
        </li>
        <li *ngIf="deviderArray && deviderArray.length"><hr class="dropdown-divider"></li>
        <li *ngFor="let item of deviderArray" (click)="onDDChangeA(item)"
        id="{{fromComponent}}-{{sectionName}}-filterAppTypeD-{{item}}">
            <a class="dropdown-item" href="javascript:void(0)">
                {{item}}
            </a>
        </li>
    </ul>
</div>